import { useSiteContent } from '@/context/SiteContent';
import { resolveImage } from '@/lib/api';

export function Products() {
  const { products } = useSiteContent();
  return (
    <section
      id="products"
      className="section-pad px-6 lg:px-12 bg-yunti-ground text-yunti-ink border-b border-yunti-ink/10"
      data-testid="products-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between pb-10 border-b border-yunti-ink/10 gap-6">
          <div>
            <p className="text-xs font-mono uppercase tracking-[0.22em] text-yunti-purple font-semibold mb-2">
              {products.eyebrow}
            </p>
            <h2 className="text-3xl md:text-5xl font-display uppercase tracking-tight text-yunti-ink">{products.title}</h2>
          </div>
          <p className="text-xs font-mono text-yunti-ink/60 uppercase tracking-widest">{products.note}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {products.items.map((product) => (
            <div
              key={product.id}
              className="bg-white border border-yunti-ink/10 p-4 flex flex-col group hover:border-yunti-ink transition-colors"
              data-testid={`product-card-${product.id}`}
            >
              <figure className="relative aspect-[3/4] bg-yunti-sand flex items-end p-4 border border-yunti-ink/5 overflow-hidden">
                {product.image ? (
                  <img
                    src={resolveImage(product.image)}
                    alt={product.alt || product.name}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center text-center p-4">
                    <span className="text-xs font-mono text-yunti-ink/40 tracking-wider uppercase">
                      [ {product.name} — image coming soon ]
                    </span>
                  </div>
                )}
                <figcaption className="relative z-10 text-[10px] font-mono uppercase tracking-widest text-yunti-green bg-white/90 px-2 py-1">
                  {product.badge}
                </figcaption>
              </figure>
              <div className="mt-4 flex items-center justify-between">
                <h3 className="font-display text-lg uppercase tracking-tight text-yunti-ink">{product.name}</h3>
                <span className="text-[11px] font-mono text-yunti-purple uppercase font-semibold">{products.previewLabel}</span>
              </div>
              <p className="text-xs text-yunti-ink/50 mt-1">{products.previewSub}</p>
            </div>
          ))}
        </div>

        <div
          className="mt-8 p-4 bg-white border border-yunti-ink/10 flex flex-col sm:flex-row sm:items-center justify-between gap-4 text-xs font-mono text-yunti-ink/60"
          data-testid="storefront-notice"
        >
          <span>{products.notice}</span>
          <span className="text-yunti-purple font-semibold">{products.noticeAccent}</span>
        </div>
      </div>
    </section>
  );
}
